"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const section_animation_1 = require("./section-animation");
const carousel_splide_1 = __importDefault(require("./carousel-splide"));
const accordion_1 = __importDefault(require("./accordion"));
const tabs_1 = __importDefault(require("./tabs"));
const nav_mobile_1 = __importDefault(require("./nav-mobile"));
const nav_desktop_1 = __importDefault(require("./nav-desktop"));
const inputs_1 = __importDefault(require("./inputs"));
const dropdown_footer_1 = __importDefault(require("./dropdown-footer"));
const order_filter_select_1 = require("./order-filter-select");
const forms_1 = __importDefault(require("./forms"));
const cookie_consent_1 = __importDefault(require("./cookie-consent"));
const modal_1 = require("./modal");
const handle_safari_select_1 = require("./handle-safari-select");
const text_feature_1 = require("./text-feature");
const job_listing_1 = require("./job-listing");
const filter_modal_1 = require("./filter-modal");
const richtext_1 = __importDefault(require("./richtext"));
const animations_1 = require("./animations");
const isAboveTablet = window.matchMedia("(min-width: 768px)");
const header = document.querySelector(".header");
const heroClasses = [".hero", ".simple-hero"];
const staggerClasses = [".accordion__container", ".testimonial"];
// // Espera al evento personalizado 'loaderHidden' para inicializar el modal
// document.addEventListener("loaderHidden", function () {
//     // Puedes poner aquí cualquier otra inicialización que dependa del loader
//     popupModalInit();
//     staggerInit();
//     staggerColsChildrensInit();
//     staggerNewsChildrensInit();
//     formsAnimation();
//     horizontalTextImageAnimation();
//     cardHoverAnimation();
//     carouselAnimation();
//     staggerAnimInit(staggerClasses);
//     heroParallaxAnimation();
//     handleRichTextLinks();
//     heroClasses.forEach((heroClass) => {
//         heroAnimInit(heroClass);
//     });
// });
window.addEventListener("load", function () {
    if (header) {
        (0, nav_mobile_1.default)();
        (0, nav_desktop_1.default)();
    }
    (0, section_animation_1.sectionAnimInit)({
        emisionesElId: "emisiones_root",
    });
    (0, accordion_1.default)();
    (0, dropdown_footer_1.default)();
    (0, order_filter_select_1.initOrderSelect)();
    (0, order_filter_select_1.initFilterSelect)();
    (0, text_feature_1.handleTextFeatureContentHeight)();
    (0, job_listing_1.setCVTargetBlank)();
    // Safari selects
    (0, handle_safari_select_1.handleSelectsInSafari)();
    isAboveTablet.onchange = (e) => {
        if (e.matches) {
            /* the viewport is 600 pixels wide or less */
            console.log("This is a narrow screen — less than 600px wide.");
        }
        else {
            /* the viewport is more than 600 pixels wide */
            console.log("This is a wide screen — more than 600px wide.");
        }
    };
    const tabs = document.querySelectorAll(".tabs");
    if (tabs.length) {
        (0, tabs_1.default)();
    }
    const carousels = [...document.querySelectorAll(".splide:not(.--graphs, .--react)")];
    const initCars = carousels.map((carousel) => {
        return (0, carousel_splide_1.default)({ carouselEl: carousel });
    });
    // Reinit the carousels when viewport changes
    isAboveTablet.onchange = () => {
        for (const carousel of initCars) {
            carousel.destroy();
            carousel.mount();
        }
    };
    (0, forms_1.default)(".form");
    (0, inputs_1.default)(".form-input-select");
    (0, cookie_consent_1.default)();
    (0, modal_1.popupModalInit)();
    (0, modal_1.redirectModalInit)();
    // Puedes poner aquí cualquier otra inicialización que dependa del loader
    // popupModalInit();
    (0, animations_1.staggerInit)();
    (0, animations_1.staggerColsChildrensInit)();
    (0, animations_1.staggerNewsChildrensInit)();
    (0, animations_1.formsAnimation)();
    (0, animations_1.horizontalTextImageAnimation)();
    (0, animations_1.cardHoverAnimation)();
    (0, animations_1.carouselAnimation)();
    (0, animations_1.staggerAnimInit)(staggerClasses);
    (0, animations_1.heroParallaxAnimation)();
    (0, richtext_1.default)();
    heroClasses.forEach((heroClass) => {
        (0, animations_1.heroAnimInit)(heroClass);
    });
    (0, filter_modal_1.modalFiltersInit)();
});
